import axios from "axios";
import {
  GrievanceType,
  GrievanceCategory,
  GrievancePriority,
  GrievanceStatus,
  GrievanceComment,
  GrievanceDetail,
  GrievanceListItem,
  UpdateGrievancePayload,
} from "../grievance/grievanceApi";

export interface StudentComplaintFilters {
  academicSessionId?: string;
  classId?: string;
  sectionId?: string;
  status?: GrievanceStatus;
  priority?: GrievancePriority;
  studentId?: string;
  type?: GrievanceType;
  category?: GrievanceCategory;
  ticketNumber?: string;
  fromDate?: string;
  toDate?: string;
}

export type StudentComplaintListItem = GrievanceListItem;

export interface StudentComplaintDetail extends GrievanceDetail {
  comments: GrievanceComment[];
}

export interface StudentComplaintListResponse {
  data: StudentComplaintListItem[];
  meta: {
    total: number;
    page: number;
    limit: number;
    stats: {
      total: number;
      open: number;
      inProgress: number;
      resolved: number;
      closed: number;
      highPriority: number;
    };
  };
}

export const studentComplaintsApi = {
  async getAll(filters: StudentComplaintFilters, page = 1, limit = 20) {
    const response = await axios.get<StudentComplaintListResponse>(
      "/scholar-register/student-complaints",
      {
        params: {
          ...filters,
          page,
          limit,
        },
      },
    );
    return response.data;
  },

  async getById(id: string) {
    const response = await axios.get<StudentComplaintDetail>(
      `/scholar-register/student-complaints/${id}`,
    );
    return response.data;
  },

  async updateStatus(id: string, payload: UpdateGrievancePayload) {
    const response = await axios.patch<StudentComplaintDetail>(
      `/scholar-register/student-complaints/${id}/status`,
      payload,
    );
    return response.data;
  },

  async addComment(id: string, payload: { comment: string }) {
    const response = await axios.post<StudentComplaintDetail>(
      `/scholar-register/student-complaints/${id}/comment`,
      payload,
    );
    return response.data;
  },
};

